import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import type { IUploadStore } from "../../UploadStore";
import { injectFromAppUpload } from "../../inject";
import { newShortGuid } from "../../../util/types/guid";
import { SelectedFilesComponent } from "./selected-files/SelectedFilesComponent";
import { action, observable } from "mobx";
import { StaticNotificationComponent } from "../../../shared-components/static-notification/StaticNotificationComponent";
import { SpanRichToolTipComponent } from "../../../shared-components/rich-tooltip/RichToolTipComponent";
import type { IUploadCodeAndSourceSelectionStore } from "../upload-code-and-source-selection/UploadCodeAndSourceSelectionStore";
import type { ICurrentUploadSettingsStore } from "../../CurrentUploadSettingsStore";
import { fireAndForget } from "../../../util/async/fireAndForget";

interface IFileSelectionComponentProps {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
    uploadCodeAndSourceSelectionStore?: IUploadCodeAndSourceSelectionStore;
    currentUploadSettingsStore?: ICurrentUploadSettingsStore;
}

@injectFromAppUpload<IFileSelectionComponentProps>(stores => ({
    uploadStore: stores.uploadStore,
    uploadCodeAndSourceSelectionStore: stores.uploadCodeAndSourceSelectionStore,
    resourcesStore: stores.resourcesStore,
    currentUploadSettingsStore: stores.currentUploadSettingsStore,
}))
@observer
export class FileSelectionComponent extends React.Component<IFileSelectionComponentProps> {
    @observable
    private inputStateKey1 = newShortGuid(); //needed to reset input files on 2nd browse, so it retriggers file selection

    @observable
    private inputStateKey2 = newShortGuid(); //needed to reset input files on 2nd browse, so it retriggers folder selection

    @action
    inputChanged = event => {
        event.preventDefault();
        const { uploadStore } = this.props;
        const { preventInputOfNewFiles } = uploadStore!;
        if (preventInputOfNewFiles) return;
        fireAndForget(uploadStore!.addSelectedFiles(event.target.files));
        this.inputStateKey1 = newShortGuid();
        this.inputStateKey2 = newShortGuid();
    };

    render() {
        const { resourcesStore, uploadStore, uploadCodeAndSourceSelectionStore, currentUploadSettingsStore } = this.props;
        const { resources } = resourcesStore!;
        const { preventInputOfNewFiles, patientsFound, inputChanged } = uploadStore!;
        const { uploadCodeAndSourceValid, selectedSourceUploadSizeLimitInGb } = uploadCodeAndSourceSelectionStore!;
        const { userUploadsWithoutCode } = currentUploadSettingsStore!;

        let selectionButtonClasses: string = "";
        if (preventInputOfNewFiles || inputChanged) {
            selectionButtonClasses = "disabled";
        } else {
            selectionButtonClasses = patientsFound.length > 0 ? "selected-files" : "";
        }

        // @ts-ignore
        return (
            <div id={"file-selection-container"} className={(patientsFound.length > 0 ? "inactive" : "active") + " " + (uploadCodeAndSourceValid ? "" : " disabled")}>
                <h2>
                    <span>1</span> {resources.SelectImagesFilesYouWishToUpload}
                </h2>
                <div className={"select-files-container"}>
                    <div className={"selection-buttons"}>
                        <div className={"selection-button " + selectionButtonClasses} id={"select-files-button"}>
                            <label>
                                {resources.SelectImagesFilesOrZipFile}
                                <input type="file" key={this.inputStateKey1} multiple disabled={preventInputOfNewFiles || inputChanged} onChange={this.inputChanged} />
                            </label>
                        </div>
                        <div className={"selection-button " + selectionButtonClasses} id={"select-folder-button"}>
                            <label>
                                {resources.SelectFolder}
                                <input
                                    type="file"
                                    key={this.inputStateKey2}
                                    disabled={preventInputOfNewFiles || inputChanged}
                                    multiple
                                    onChange={this.inputChanged}
                                    {...{ webkitdirectory: "", mozdirectory: "", directory: "" }}
                                />
                            </label>
                        </div>
                    </div>
                    <div className={"selection-drag-and-drop " + selectionButtonClasses} id={"select-drag-and-drop"}>
                        <label>{resources.DragAndDropImagesFiles}</label>
                    </div>
                    <StaticNotificationComponent type={"info"} title={resources.UploadInformation}>
                        <p>{resources.UploadInformationDICOMFiles}</p>
                        <p>
                            <SpanRichToolTipComponent
                                className={"inline-link"}
                                toolTipContent={
                                    <div>
                                        {resources.NonDICOMFilesInfo}
                                        <br />
                                        <br />
                                        {resources.DICOMDIRFilesAreUnnecessaryAndWillBeIgnored}
                                    </div>
                                }
                            >
                                {resources.NonDICOMFiles}
                            </SpanRichToolTipComponent>{" "}
                            {resources.UploadInformationOtherTypes.replace("{0}", "")}
                        </p>
                        {!userUploadsWithoutCode && <p>{resources.UploadSizeLimit.replace("{0}", selectedSourceUploadSizeLimitInGb + "GB")}</p>}
                    </StaticNotificationComponent>
                </div>
                <SelectedFilesComponent />
            </div>
        );
    }
}
